module.exports = __webpack_public_path__ + "media/images/client/sponsor_logo-e9dbb89a21cbbd087862d63f7f9911a9.png";